import { useHistory } from 'react-router-dom';

export const RedirectApp = () => {
	let history = useHistory();
	history.push('/DS');
	return null;
};
